/*
 * INFO: This code was used to show the getstarted panel 3 times. Currently the cookie is used to show the Welcome modal once.
 */

export const start = () => {
  if (!hasCookie()) {
    setCookie(START_VALUE);
  }
};

export const decrement = () => {
  const num = getCookieValue();
  if (num === undefined) return;

  if (num === 1) {
    remove();
  } else {
    setCookie(num - 1);
  }
};

export const isActive = () => (getCookieValue() || -1) > 0;

export const remove = () => {
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;  domain=${domain}; path=/; secure; samesite`;
};

//// Internals:

const START_VALUE = 3;
const COOKIE_NAME = 'cartwheelGetStarted';
const domain = window.location.hostname.includes('localhost')
  ? 'localhost'
  : '.getcartwheel.com';

function hasCookie() {
  return !!document.cookie.includes(`${COOKIE_NAME}=`);
}

function setCookie(value: number) {
  document.cookie = `${COOKIE_NAME}=${value}; domain=${domain}; path=/; secure; samesite`;
}

function getCookieValue() {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((cookie) => cookie.startsWith(COOKIE_NAME));
  if (cookie) {
    const num = cookie.split('=')[1];
    return Number(num);
  }
}
